import { DVIRQuestion } from "../../../models";

export const getDVIRQuestion = (data: any): DVIRQuestion => {
  return {
    id: data.id,
    questionText: data.attributes.question_text,
    questionType: data.attributes.question_type,
    templateCount: data.attributes.template_count || 0,
  };
};

export const getDVIRQuestions = (data: any): DVIRQuestion[] => {
  return data.map(getDVIRQuestion);
};
